import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { fetchUser } from '../actions/users';
import { NotebookTabs } from 'lucide-react';
import { Link } from 'react-router-dom';
import { API_ROOT } from '../config';
import TrainingPageHeader from '../components/TrainingPageHeader';
import '../styles/TrainingAdminView.css';

const renumberOrders = (formations) => {
  const ordered = [...formations]
    .filter(f => f.order != null)
    .sort((a, b) => a.order - b.order)
    .map((f, i) => ({ ...f, order: i + 1 }));
  const unordered = formations.filter(f => f.order == null);
  return [...ordered, ...unordered];
};

class TrainingAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formations:[],
      loading:true,
      orderDirty: false,
      savingOrder: false,
      filterOpen: false,
      filters: {
        name: '',
        customer: ''
      },
    };
    this.toggleFilter = this.toggleFilter.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
  }

  toggleFilter() {
    this.setState(prev => ({ filterOpen: !prev.filterOpen }));
  }

  handleFilterChange(key, value) {
    this.setState(prev => ({
      filters: { ...prev.filters, [key]: value }
    }));
  }

  clearFilters() {
    this.setState({ filters: { name: '', customer: '' } });
  }

  moveFormation = (slug, direction) => {
    const { formations } = this.state;
    const ordered = [...formations]
      .filter(f => f.order != null)
      .sort((a, b) => a.order - b.order);
    const idx = ordered.findIndex(f => f.slug === slug);
    const swapIdx = idx + direction;
    if (swapIdx < 0 || swapIdx >= ordered.length) return;

    [ordered[idx].order, ordered[swapIdx].order] = [ordered[swapIdx].order, ordered[idx].order];

    const unordered = formations.filter(f => f.order == null);
    this.setState({
      formations: renumberOrders([...ordered, ...unordered]),
      orderDirty: true,
    });
  };

  saveOrder = async () => {
    const { formations } = this.state;
    this.setState({ savingOrder: true });
    const token = localStorage.getItem('token');
    await Promise.all(
      formations
        .filter(f => f.order != null)
        .map(f =>
          fetch(`${API_ROOT}formations/${f.slug}/order`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
            body: JSON.stringify({ order: f.order })
          })
        )
    );
    this.setState({ savingOrder: false, orderDirty: false });
  };

  removeOrder = (slug) => {
    const { formations } = this.state;
    const withoutTarget = formations.map(f => f.slug === slug ? { ...f, order: null } : f);
    const renumbered = renumberOrders(withoutTarget);
    this.setState({ formations: renumbered, orderDirty: true });
  };

  orderAddFormation = (slug) => {
    const { formations } = this.state;
    const maxOrder = formations.reduce((max, f) => (f.order != null && f.order > max ? f.order : max), 0);
    const updated = formations.map(f => f.slug === slug ? { ...f, order: maxOrder + 1 } : f);
    this.setState({ formations: renumberOrders(updated), orderDirty: true });
  };

  deleteFormation = async (slug, e) => {
    e.stopPropagation();
    if (!window.confirm('¿Eliminar esta formación? Esta acción no se puede deshacer.')) return;
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_ROOT}formations/${slug}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!res.ok) throw new Error('Error al eliminar la formación');
      this.setState(prev => ({ formations: prev.formations.filter(f => f.slug !== slug) }));
    } catch (err) {
      alert(err.message);
    }
  };

  async componentDidMount() {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_ROOT}formations`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      this.setState({ formations: data, loading: false });
    } catch(err) {
      console.error('Error fetching formations:', err);
      this.setState({ loading: false });
    }
  }

  orderAddedFormation = (newFormation) => {
    this.setState(prev => ({
      formations: [...prev.formations, newFormation],
      orderDirty: true
    }));
  }


  render() {
    const { filterOpen, filters, formations, orderDirty, savingOrder } = this.state;

    const sorted = [...formations].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    const filtered = sorted.filter(t => {
      const matchName = filters.name === '' || t.name.toLowerCase().includes(filters.name.toLowerCase());
      const matchCustomer = filters.customer === '' || t.customer === filters.customer;
      return matchName && matchCustomer;
    });

    return (
        <div>
      <div>
        <TrainingPageHeader
          icon={<NotebookTabs size={30} />}
          title="Training Admin"
          actions={
            <>
              {orderDirty && (
                <button
                  className="customers-admin-btn primary"
                  onClick={this.saveOrder}
                  disabled={savingOrder}
                >
                  <i className="fas fa-save"></i>
                  <span>{savingOrder ? 'Guardando...' : 'Guardar orden'}</span>
                </button>
              )}
              <Link to="/training/add" className="customers-admin-btn primary">
                <i className="fas fa-plus"></i>
                <span>Crear Formacion</span>
              </Link>
            </>
          }
        />
      </div>
         <div className="mach-admin-filter-card">
          <div className="mach-admin-filter-header" onClick={this.toggleFilter}>
            <h3><i className="fas fa-filter"></i><span> Filtros</span></h3>
            <i className={`fas fa-chevron-down toggle-icon ${filterOpen ? 'open' : ''}`}></i>
          </div>
          {filterOpen && (
            <div className="mach-admin-filter-body">
              <div className="filter-grid">
                <div className="filter-group">
                  <label htmlFor="filter-serial">Nombre</label>
                  <input
                    id="filter-serial"
                    type="text"
                    placeholder="Buscar por nombre..."
                    value={filters.name}
                    onChange={(e) => this.handleFilterChange('name', e.target.value)}
                  />
                </div>
                
                <div className="filter-group">
                 
                </div>
                    <div className="filter-group">
                    <button className="training-filter-btn clear" onClick={this.clearFilters}>
                        <i className="fas fa-broom"></i><span> Limpiar filtros</span>
                    </button>
                    </div>
              </div>
            </div>
          )}
        </div>

      <div className ="training-admin-content">
        <div className="training-results-info">
          {`${filtered.length} formacion${filtered.length !== 1 ? 'es' : ''} encontrada${filtered.length !== 1 ? 's' : ''}`}
        </div>
        {filtered.length === 0 ? (
          <div className="mach-admin-empty">
            <i className="fas fa-search"></i>
            <p>No se encontraron formaciones con los filtros aplicados.</p>
          </div>
        ) : (
          <div className="training-table-wrapper">
          <table className="training-table">
            <thead>
              <tr>
                <th>Orden</th>
                <th>Nombre</th>
                <th>Obligatoria</th>
                <th>Fecha de creación</th>
                <th>Número de bloques</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((t, idx) => (
                <tr key={t._id} style={{cursor:'pointer'}} onClick={() => this.props.history.push(`/training/${t.slug}/edit`)}>
                  <td className = "font-weight-bold">{t.order > 0 ? t.order : t.order == null ? 'Siempre accesible' : 'error'}</td>
                  <td>{t.name}</td>
                  <td>{t.mandatory ? 'Si' : 'No'}</td>
                  <td>{t.createdAt ? new Date(t.createdAt).toLocaleDateString() : 'No disponible'}</td>
                  <td>{t.blocks ? t.blocks.length : 0}</td>
                  <td onClick={(e) => e.stopPropagation()} style={{whiteSpace:'nowrap',gap:'5px'}}>
                    <div style={{display:'flex', gap:'5px'}}>
                    <button
                      className="move-btn"
                      disabled={idx === 0}
                      onClick={() => this.moveFormation(t.slug, -1)}
                    >▲</button>
                    <button
                      className="move-btn"
                      disabled={idx === filtered.length - 1}
                      onClick={() => this.moveFormation(t.slug, 1)}
                    >▼</button>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={(e) => this.deleteFormation(t.slug, e)}
                    >
                      <i className="fas fa-trash" />
                    </button>
                    {t.order == null && <button onClick={() => this.orderAddFormation(t.slug)} className="btn btn-sm btn-outline-primary">Añadir orden</button>}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
         </div>
        )}
      </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    user: state.users.user,
    error: state.users.error
  }),
  dispatch => ({
    fetchUser: bindActionCreators(fetchUser, dispatch)
  })
)(TrainingAdmin);


